class ExtraExperiments {
  constructor() {
    this.arr = [];
  }

  has(expNames) {
    if (expNames.constructor.name !== "Array") {
      /*if (_sf.debug) {
        console.error('Prop "expNames" is not an array');
      }*/
      return false;
    }
    for (var i = 0; i < expNames.length; i++) {
      if (isString(expNames[i]) === false) return false;
      if (this.arr.indexOf(expNames[i]) !== -1) {
        return true;
      }
    }
    return false;
  };

  /**
   * @param {string} expName Имя эксперимента
   * @return {boolean}
   */
  add(expName) {
    if (isString(expName) === false) return false;
    if (this.has([expName]) === false) {
      this.arr.push(expName);
    }
    return true;
  };

  /**
   * @param {string} expName Имя эксперимента
   * @return {boolean}
   */
  remove(expName) {
    if (isString(expName) === false) return false;

    const expIndex = this.arr.indexOf(expName);
    if (expIndex === -1) return false;

    this.arr.splice(expIndex, 1);
    return true;
  };
}

function isString(value) {
  return typeof value === "string";
}

export default ExtraExperiments;
